import { t } from "helpers/localization";


export const METRIC_TYPES_STRINGS = {
  cvc_game_days: t('Игровые дни'),
  average_ship_level: t('Средний уровень кораблей'),
  average_stars: t('Среднее количество звезд'),
  average_oper_battles: t('Бои в Операциях')
};

export const BATTLE_TYPES = {
  COOPERATIVE: 'pve',
  PVP: 'pvp',
  SOLO_RANK: 'rank_solo',
  REGULAR_CVC: 'cvc',
  BRAWL_CVC: 'brawl',
  CLUB: 'club'
};

export const BATTLE_TYPES_STRINGS = {
  cvc: t('Клановые бои'),
  oper: t('Операции'),
  pvp: t('Случайные бои в отряде')
};

export const LANGUAGES = {
  'az': 'Azərbaycanca',
  'be': 'Беларуская',
  'bg': 'Български',
  'bs': 'Bosanski',
  'cs': 'Čeština',
  'da': 'Dansk',
  'de': 'Deutsch',
  'el': 'Ελληνικά',
  'en': 'English',
  'en-us': 'English (US)',
  'es': 'Español',
  'es-mx': 'Español (México)',
  'et': 'Eesti',
  'fi': 'Suomi',
  'fil': 'Filipino',
  'fr': 'Français',
  'hr': 'Hrvatski',
  'hu': 'Magyar',
  'hy': 'Հայերեն',
  'id': 'Indonesia',
  'it': 'Italiano',
  'ja': '日本語',
  'ka': 'ქართული',
  'kk': 'Қазақша',
  'ko': '한국어',
  'ky': 'Кыргызча',
  'lt': 'Lietuvių',
  'lv': 'Latviešu',
  'mol': 'Moldovenească',
  'ms': 'Bahasa Melayu',
  'nl': 'Nederlands',
  'no': 'Norsk',
  'pl': 'Polski',
  'pt': 'Português',
  'pt-br': 'Português (Brasil)',
  'ro': 'Română',
  'ru': 'Русский',
  'sk': 'Slovenčina',
  'sq': 'Shqip',
  'sr': 'Српски',
  'sv': 'Svenska',
  'tg': 'Тоҷикӣ',
  'th': 'ไทย',
  'tk': 'Türkmençe',
  'tr': 'Türkçe',
  'uk': 'Українська',
  'uz': 'Oʻzbekcha',
  'vi': 'Tiếng Việt',
  'zh-cn': '简体中文',
  'zh-tw': '繁體中文',
}